import Route from '@ember/routing/route';

export default class OTimingPointsRoute extends Route 
{
	model() 
	{
		return this.modelFor("event");
	}
}
